var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { getLocalStorageValue, setLocalStorage } from './local-storage-utils';
var LocalStorageKey = 'vrlcm-recent-visited-url';
var IgnoreAbsolutePaths = [
    '/lcm/lcops',
    '/lcm/authzn',
    '/lcm/marketplace',
    '/lcm/marketplace/list',
    '/lcm/cms',
    '/lcm/locker',
    '/lcm/migrate',
    '/lcm/cloud'
];
var getRecentVisitedPagesFromStore = function (user) {
    var storedMap = getLocalStorageValue(LocalStorageKey);
    return storedMap && storedMap[user]
        ? storedMap[user].map(function (p) { return (__assign(__assign({}, p), { when: new Date(p.when) })); })
        : [];
};
var setRecentVisitedPagesInStore = function (user, items, maxCount) {
    if (maxCount === void 0) { maxCount = 10; }
    var storedMap = getLocalStorageValue(LocalStorageKey);
    if (!storedMap) {
        storedMap = {};
    }
    storedMap[user] = items.slice(0, maxCount);
    setLocalStorage(LocalStorageKey, storedMap);
};
var fetchAppName = function (urlWithoutHost) {
    var appName = urlWithoutHost.split('/')[2];
    if (appName === 'cloud') {
        appName = 'cloudproxy';
    }
    return appName;
};
export var recentVisitedPageByUserUtil = (function () {
    var onChangeCallbacks = [];
    var addCurrentPage = function (user) {
        var _a = window.location, pathname = _a.pathname, search = _a.search, hash = _a.hash;
        var urlWithoutHost = pathname + search + hash;
        if (!urlWithoutHost.startsWith('/lcm') ||
            urlWithoutHost.split('/').filter(function (p) { return p; }).length < 2) {
            return;
        }
        if (IgnoreAbsolutePaths.some(function (path) { return path === urlWithoutHost || path + "/" === urlWithoutHost; })) {
            return;
        }
        var updatedRecentVisitedPages = getRecentVisitedPagesFromStore(user)
            .filter(function (r) { return r.urlWithoutHost !== urlWithoutHost; })
            .concat([
            {
                app: fetchAppName(urlWithoutHost),
                urlWithoutHost: urlWithoutHost,
                when: new Date()
            }
        ])
            .sort(function (a, b) { return b.when.getTime() - a.when.getTime(); });
        setRecentVisitedPagesInStore(user, updatedRecentVisitedPages);
        onChangeCallbacks.forEach(function (cb) { return cb(updatedRecentVisitedPages); });
    };
    var getRecentVisitedPages = function (user) {
        return getRecentVisitedPagesFromStore(user);
    };
    var removeVisitedPage = function (user, page) {
        var updatedRecentVisitedPages = getRecentVisitedPagesFromStore(user).filter(function (p) {
            return !(p.urlWithoutHost === page.urlWithoutHost &&
                p.when.getTime() === page.when.getTime());
        });
        setRecentVisitedPagesInStore(user, updatedRecentVisitedPages);
        onChangeCallbacks.forEach(function (cb) { return cb(updatedRecentVisitedPages); });
        return updatedRecentVisitedPages;
    };
    var onChange = function (callback) {
        return (onChangeCallbacks = __spreadArrays(onChangeCallbacks, [callback]));
    };
    return {
        getRecentVisitedPages: getRecentVisitedPages,
        addCurrentPage: addCurrentPage,
        removeVisitedPage: removeVisitedPage,
        onChange: onChange
    };
})();
